import { render, staticRenderFns } from "./NewProductCategoryModal.vue?vue&type=template&id=429814fe&"
import script from "./NewProductCategoryModal.vue?vue&type=script&lang=js&"
export * from "./NewProductCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports